import React, { useEffect, useRef, useState } from 'react';
import DocumentMeta from 'react-document-meta';
import { ConfirmPopup } from 'shared/components/ConfirmPopup';
import { sendEvent } from 'shared/helpers/requests';
import styles from './OneToMany.module.scss';
import { FirstBlock } from './components/FirstBlock';
import { SecondBlock } from './components/SecondBlock';
import { ThirdBlock } from './components/ThirdBlock';
import { FourthBlock } from './components/FourthBlock';
import { FifthBlock } from './components/FifthBlock';
import { ReactComponent as FooterLogo } from './images/logo_footer.svg';
import { EVENT_SOURCE, EVENT_TYPE } from './constants';
import { useFetchTestData } from './hooks/useFetchTestData';
import { getPrice } from './utils';

export function OneToMany() {
  const [isValidationBlockVisible, setIsValidationBlockVisible] = useState(false);

  const thirdBlockRef = useRef<HTMLDivElement>(null);

  const { isCourses, isSubjects, courseParallel, isSubscription, isLongControl } =
    useFetchTestData();

  const price = getPrice(isCourses, isSubjects);

  const goToFakeDoor = () => {
    let linkPart = '';
    if (isSubscription) linkPart = 'liveBroadcastSub';
    else if (isSubjects) linkPart = 'liveBroadcastSchool';
    else if (isCourses) linkPart = 'liveBroadcastMini';

    window.location.href = `https://uchi.ru/payments/provider/${linkPart}`;
  };

  useEffect(() => {
    if (isCourses) {
      sendEvent({
        eventSource: EVENT_SOURCE.COURSES,
        eventType: EVENT_TYPE.VISIT_LAND,
        eventInfo: '',
      });
    }
    if (isSubjects) {
      sendEvent({
        eventSource: EVENT_SOURCE.SHKOLA,
        eventType: EVENT_TYPE.VISIT_LAND,
        eventInfo: '',
      });
    }
    if (isSubscription) {
      sendEvent({
        eventSource: EVENT_SOURCE.PODPISKA,
        eventType: EVENT_TYPE.VISIT_LAND,
        eventInfo: '',
      });
    }
  }, [isCourses, isSubjects, isSubscription]);

  const goToUchiMain = () => {
    window.location.assign(`https://uchi.ru/`);
  };

  const goToThirdBlock = () => {
    thirdBlockRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const onValidationOpen = () => {
    setIsValidationBlockVisible(true);
    sendEvent({
      eventSource: isSubjects
        ? EVENT_SOURCE.SHKOLA
        : EVENT_SOURCE[isCourses ? 'COURSES' : 'PODPISKA'],
      eventType: EVENT_TYPE.SEEN_CAPCHA,
      eventInfo: '',
    });
  };

  const handlePopupClose = () => {
    setIsValidationBlockVisible(false);
    sendEvent({
      eventSource: isSubjects
        ? EVENT_SOURCE.SHKOLA
        : EVENT_SOURCE[isCourses ? 'COURSES' : 'PODPISKA'],
      eventType: EVENT_TYPE.CLICK_BACK_CAPCHA,
      eventInfo: '',
    });
  };

  const onValidationFailure = (answer: string) => {
    sendEvent({
      eventSource: isSubjects
        ? EVENT_SOURCE.SHKOLA
        : EVENT_SOURCE[isCourses ? 'COURSES' : 'PODPISKA'],
      eventType: EVENT_TYPE.CAPCHA_WRONG,
      eventInfo: JSON.stringify({ answer }),
    });
  };

  const onValidationSuccess = () => {
    handlePopupClose();
    goToFakeDoor();
  };

  if (isLongControl) {
    window.location.assign('https://uchi.ru');
  }

  return (
    <div className={styles.root}>
      <DocumentMeta title="Прямые эфиры для начальной школы | Учи.ру" />
      <FirstBlock
        price={price}
        isCourses={isCourses}
        isSubscription={isSubscription}
        isSubjects={isSubjects}
        onValidationOpen={onValidationOpen}
        goToUchiMain={goToUchiMain}
        goToThirdBlock={goToThirdBlock}
      />
      <SecondBlock isSubjects={isSubjects} />
      <ThirdBlock
        price={price}
        isSubscription={isSubscription}
        isCourses={isCourses}
        isSubjects={isSubjects}
        courseParallel={courseParallel}
        thirdBlockRef={thirdBlockRef}
        onValidationOpen={onValidationOpen}
      />
      <FourthBlock />
      <FifthBlock
        price={price}
        isCourses={isCourses}
        isSubjects={isSubjects}
        isSubscription={isSubscription}
        onValidationOpen={onValidationOpen}
        goToThirdBlock={goToThirdBlock}
      />
      <footer className={styles.footer}>
        <FooterLogo className={styles.logo} onClick={goToUchiMain} />
      </footer>
      <div className={styles.validationBlockWrapper}>
        <ConfirmPopup
          validationBlockTitle="Позови родителя!"
          validationBlockWarning={`Решите пример и узнайте о полном\nдоступе`}
          isVisible={isValidationBlockVisible}
          isSent={false}
          onClose={handlePopupClose}
          onValidationSuccess={onValidationSuccess}
          onValidationFailure={onValidationFailure}
        />
      </div>
    </div>
  );
}
